<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <largest-three-month-move :data="data" />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <largest-six-month-move :data="data" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LargestThreeMonthMove from '@/theme/default/views/banking/risk/interest-rate/EVE/sharpest-eve-changes/LargestThreeMonthMove'
import LargestSixMonthMove from '@/theme/default/views/banking/risk/interest-rate/EVE/sharpest-eve-changes/LargestSixMonthMove'

export default {
  name      : 'SharpestEVEChanges',
  components: {
    LargestThreeMonthMove,
    LargestSixMonthMove
  },
  props: {
    data: {
      type   : Object,
      default: () => null
    }
  },
  data () {
    return {}
  }

}
</script>

<style scoped>
</style>
